import Vue from 'vue'
import Vuex from 'vuex'

import createPersistedState from 'vuex-persistedstate'

import app from '@/store/modules/app'
import auth from '@/store/modules/auth'
import http from '@/store/modules/http'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    auth,
    http
  },
  plugins: [createPersistedState({
    key: 'info.space',
    //storage: window.sessionStorage
  })]
})
